<template>
  <v-card>
    <v-card-title class="secondary white--text">{{ $t('change_password') }}</v-card-title>
    <div class="pa-8">
      <form-group :name="$t('form.oldpassword')" :validator="$v.form.oldPassword">
        <template slot-scope="{ attrs }">
          <v-text-field
            v-model="form.oldPassword"
            v-bind="attrs"
            :append-icon="!showOldPassword ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showOldPassword ? 'text' : 'password'"
            :label="$t('form.oldpassword')"
            @click:append="showOldPassword = !showOldPassword"
            @input="$v.form.oldPassword.$touch()"
            @blur="$v.form.oldPassword.$touch()"
          >
          </v-text-field>
        </template>
      </form-group>

      <form-group :name="$t('form.password')" :validator="$v.form.newPassword">
        <template slot-scope="{ attrs }">
          <v-text-field
            v-model="form.newPassword"
            v-bind="{ ...attrs, errorMessages: attrs.errorMessages?.filter(msg => msg.includes('required')) }"
            :append-icon="!showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showPassword ? 'text' : 'password'"
            :label="$t('form.password')"
            @click:append="showPassword = !showPassword"
            @input="$v.form.newPassword.$touch()"
            @blur="$v.form.newPassword.$touch()"
          >
          </v-text-field>
        </template>
      </form-group>

      <PasswordRequirements :model-value="form.newPassword" />

      <form-group :name="$t('form.pass2')" :validator="$v.form.confirmNewPassword">
        <template slot-scope="{ attrs }">
          <v-text-field
            v-model="form.confirmNewPassword"
            v-bind="attrs"
            :append-icon="!showPasswordRetype ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showPasswordRetype ? 'text' : 'password'"
            :label="$t('form.pass2')"
            @click:append="showPasswordRetype = !showPasswordRetype"
            @input="$v.form.confirmNewPassword.$touch()"
            @blur="$v.form.confirmNewPassword.$touch()"
          >
          </v-text-field>
        </template>
      </form-group>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" outlined class="btn-primary-custom mr-2" @click="hide">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" class="btn-primary-custom" @click="save" :loading="loading">{{ $t('save') }}</v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
import { hasNumber, hasSpecialChar, hasUppercase } from '@/validators/shared';
import { required, sameAs, minLength } from 'vuelidate/lib/validators';
import PasswordRequirements from './PasswordRequirements.vue';

export default {
  name: 'ChangePassword',
  components: {
    PasswordRequirements
  },
  props: {
    force: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    form: {
      oldPassword: { required },
      newPassword: { required, minLength: minLength(6), hasNumber, hasUppercase, hasSpecialChar },
      confirmNewPassword: { required, sameAsPassword: sameAs('newPassword') }
    }
  },
  data: () => ({
    form: {
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: ''
    },
    showOldPassword: false,
    showPassword: false,
    showPasswordRetype: false,
    loading: false
  }),
  methods: {
    hide() {
      this.form.oldPassword = '';
      this.form.newPassword = '';
      this.form.confirmNewPassword = '';
      this.$v.$reset();
      this.$emit('hide');
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      this.loading = true;
      this.axios
        .post('api/profile', this.form)
        .then(() => this.$router.push({ name: 'UserProfileUpdate' }))
        .finally(() => (this.loading = false));
    }
  }
};
</script>
